<template>
  <div class="vx-row">
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
      :collapse-action="true">
      <div class="vx-row">
        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
          <label class="text-sm opacity-100 text-bold">General Search</label>
          <vs-input type="text" v-model="filters['search']" class="w-full mb-4 md:mb-0" />
        </div>
        <div class="w-full vx-col md:w-1/3 sm:w-1/2" v-if="!id">
          <label class="text-sm text-bold">Company</label>
          <v-select :clearable="true" v-model="filters['Company']" :options="company_list" class="w-full"
            label="Name" :reduce="option => option._id">
          </v-select>
        </div>
      </div>
      <div class="mt-5 vx-row">
        <div class="w-full ml-auto vx-col">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="filters = {}">CLEAR
          </vs-button>
        </div>
      </div>
    </vx-card>

    <vx-card title="" v-can:any="['view-company', 'create-company']">
      <template slot="actions">
        <div class="flex float-right">
          <div class="con-btns-user flex items-center justify-between">
            <div class="flex mb-4">
              <vs-button v-can="'create-company'" @click="onClickCreateTenant" class="mr-4" color="primary"
                type="filled">New</vs-button>
              <vs-button v-can="'view-company'" @click="onClickRefresh" class="mr-0" color="success" type="border"
                icon-pack="feather" icon="icon-rotate-cw"></vs-button>
            </div>
          </div>
        </div>
      </template>
      <div slot="no-body" class="mt-4">
        <vs-table :max-items="(meta.pageSize) ? meta.pageSize : 10" id="tenants-table" :data="tenants_list"
          @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

          <template slot="thead">
            <vs-th width="10%">Company Name</vs-th>
            <vs-th width="10%">Company Type</vs-th>
            <vs-th width="10%">Created At</vs-th>
            <vs-th width="15%">ACTION</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr class="cursor-pointer"
              @click.native="onClickTenantView(data[indextr]._id)" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].Name">
                <span class="text-primary"> {{ data[indextr].Name }}</span>
              </vs-td>

              <vs-td :data="data[indextr].Type">
                {{ data[indextr].Type || 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].createdAt">
                {{ __dateTimeFormatter(data[indextr].createdAt) }}
              </vs-td>


              <vs-td>
                <div class="vx-row">
                  <vx-tooltip v-can="'view-company'" class="mr-2" text="Open" position="top">
                    <vs-button @click.stop="onClickTenantView(data[indextr]._id)" size="small" color="success" type="border"
                      icon-pack="feather" icon="icon-eye"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-can="'update-company'" class="mr-2" text="Update & Quick View" position="top">
                    <vs-button @click.stop="onClickUpdate(data[indextr])" size="small" color="warning" type="border"
                      icon-pack="feather" icon="icon-edit-2"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-can="'delete-company'" class="mr-2" text="Delete Company" position="top">
                    <vs-button @click.stop="onClickDeleteConfirm(data[indextr]._id)" size="small" color="danger" type="border"
                      icon-pack="feather" icon="icon-trash-2"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>


        </vs-table>
        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.pageSize ? meta.pageSize : 20"
          :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
          description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
          v-model="page" class="p-5">
        </vs-pagination>

      </div>
    </vx-card>
    <CreateObjectPopUp ref="createObjectPopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import vSelect from 'vue-select'
const TenantRepository = RepositoryFactory.get('tenant')
const ObjectRepository = RepositoryFactory.get('object')
const DropDownRepository = RepositoryFactory.get('drop_down')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList, MASTER_TENANT_DOMAIN } from "@/constants/config";
import CreateObjectPopUp from "@/components/popups/general/CreateObjectPopUp.vue"

export default {
  name: 'TenantList',
  data() {
    return {
      tenants_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      object_name: 'account',
      company_list: []
    }
  },
  components: {
    'v-select': vSelect,
    CreateObjectPopUp
  },
  async mounted() {
    await this.fetchCompanyList()
  },
  methods: {
    async refreshData() {
      await this.fetchTenants()
    },
    async onClickTenantView(id) {
      await this.$router.push({ path: `/pages/companies/${id}` })
    },
    async fetchTenants() {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        const { data } = (await TenantRepository.get(this.page, this.filterQuery, this.perPage, this.sort)).data
        console.log(data);
        this.tenants_list = data.data
        this.meta = data.pagination
        this.meta.last_page = Math.ceil(this.meta.totalRecords / this.meta.pageSize)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
    async onClickCreateTenant() {
      await this.$refs.createObjectPopUp.openPopup(this.object_name, 'create', { OwnerId: this.$store.getters.currentUserId })
    },
    async onClickUpdate(data) {
      await this.$refs.createObjectPopUp.openPopup(this.object_name, 'update', data)
    },
    async onClickRefresh() {
      await this.fetchTenants()
    },
    async fetchCompanyList() {
      try {
        const { data } = (await DropDownRepository.fetchObjectsList('account')).data
        this.company_list = data.data
      } catch (e) {
        console.log(e);
      }
    },
    filterQueryUpdate() {
      this.page = 1
      this.fetchTenants()
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchTenants()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchTenants()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    async onClickDeleteConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        acceptText: 'Delete',
        text: `Are you sure you want to delete this action?`,
        accept: this.onClickDelete,
        parameters: [ id ]
      })
    },
    async onClickDelete(parama) {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        await ObjectRepository.deleteObject(this.object_name, parama[0])
        this.fetchTenants()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
  },
  watch: {
    page() {
      this.fetchTenants()
    },
    perPage() {
      this.fetchTenants()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped></style>
